// List of QoS to be filtered from payload if IP Proxy is enabled
module.exports = [
  'audioLocalAddress',
  'audioRemoteAddress',
  'videoLocalAddress',
  'videoRemoteAddress',
];
